<template>
    <banner :bgImage="bannerInfo.file || bgImage"  :title="bannerInfo.title" :subTitle="bannerInfo.desc"></banner>
    <div class="main-bg" v-if="status==0">
        <div class="con-top flex">
            <div class="con-left">
                <Ani class="con-item">
                    <div class="box-title">
                        <h2 class="box-h2 font36 color-f">{{ t('contact.style') }}</h2>
                    </div>
                    <div class="con-text font16 color-f">
                        <p class="phone">{{way.phone}}</p>
                        <p class="address">{{way.address}}</p>
                    </div>
                </Ani>
                <Ani class="con-item">
                    <div class="box-title">
                        <h2 class="box-h2 font36 color-f">{{ t('contact.selfMedia') }}</h2>
                    </div>
                    <ul class="con-channel list-style flex flex-wrap font16 color-f text-center">
                        <li v-for="(item,index) in  channel.dataList" :key="index">
                            <a :href="item.url" target="_blank" rel="nofollow noopener noreferrer">
                                <div class="con-icon flex-center">
                                    <img :src="item.icon" :alt="item.title || ''">
                                </div>
                                <p class="color-f">{{item.title}}</p>
                            </a>
                        </li>
                    </ul>
                </Ani>
            </div>
            <Ani ID="ani-con-map" class="con-map" :options="aniOptions('right')">
                <Map :way="way"></Map>
            </Ani>
        </div>
        <div class="wrap">
            <div class="con-bot">
                <Ani class="box-title text-center">
                    <h2 class="box-h2 font36 color-f">{{ t('contact.moreContact') }}</h2>
                </Ani>
                <Ani>
                    <ul class="con-list list-style flex flex-wrap">
                        <li v-for="(item, index) in moreWay?.dataList" :key="index">
                            <div class="con-item">
                                <h3 class="con-title font24 color-f">{{item.title}}</h3>
                                <div class="con-text font16 color-f">
                                    <p class="phone"  v-for="child in item.phones">{{ child }}</p>
                                    <p class="email"  v-for="child in item.emails" :key="child">{{ child }}</p>
                                </div>
                            </div>
                        </li>
                    </ul>
                </Ani>
            </div>
        </div>
    </div>
    <error :status="status" v-if="status>0"></error>
</template>
<script setup lang="ts"> 
    import { ref } from 'vue'
    import useServerRequest from '@/composables/useServerRequest'
    import type { configParams, configResponse,bannerConfig } from '~/types'
    import { useI18n } from 'vue-i18n'
    import { Picture } from '@element-plus/icons-vue'
    import { handleApiResponse } from "@/utils/utils"
    // import { aniOptions } from "@/utils/ani";
    import { useRoute } from 'vue-router'
    const config = useRuntimeConfig()
    const cmsurlStrategy = config?.public?.cmsStrategy

    // 2. 获取当前路由和语言
    const route = useRoute()
    const { locale,t } = useI18n()

    // 3. 初始化响应式数据
    const bgImage = ref<string>(staticURL('/banner/contact-banner.webp'))
    const status = ref<number>(0)

    // 5. 配置信息
    //其他信息 
    const seo = ref<configResponse['pageValue']['seo']>({
    title: '',
    keywords: '',
    desc: ''
    })
    const bannerInfo = ref<bannerConfig>({})
    const way = ref<configResponse['pageValue']['way']>({
        phone: '',
        address: '',
        companyName: '',
        fax: '',
        location: ''
    })
    const channel = ref<configResponse['pageValue']['channel']>({
        dataList: []
    })
    const moreWay = ref<configResponse['pageValue']['moreWay']>({
        dataList: []
    })
    const infoParams = ref<configParams>({
        pageCode: "CONTACT_US"
    })
    const getInfo = async () => {
        try {
            const { data } = await useServerRequest<configResponse>(
                'contact-info',
                `${cmsurlStrategy}/getPageConfig`,
                { method: 'GET', params: infoParams.value, language: locale.value }
            )
            const res = data?.value
            const result = handleApiResponse(res)
            if (!result.success) {
                status.value = result.status
                return
            }
            const getInfoData = data?.value?.data?.pageValue
            seo.value = getInfoData?.seo
            way.value = getInfoData?.way || {}
            channel.value = getInfoData?.channel
            bannerInfo.value = getInfoData?.banner?.[0] || {}; // 链式判断 + 默认值
            moreWay.value =  getInfoData?.moreWay
            console.log(moreWay.value)
            
        
        } catch (error) {
            status.value = 2
        }
    }
    getInfo()
    useHead({
        title: () => seo?.value?.title || '', // 保持不变（已正确）
        meta: [
          { 
            name: 'keywords', 
            content: () => seo?.value?.keywords || '' // 改为函数形式！
          },
          { 
            name: 'description', 
            content: () => seo?.value?.desc || '' // 改为函数形式！（去掉多余的模板字符串）
          }
        ]
    })
    
    const splitStr = (str: string) => {
        if (!str) {
            return []
        }
        if (str.includes(',')) {
            return str.split(',')
        }
        return str.split('、')
    }
    

</script>
<style scoped lang="scss">
@use '@/assets/css/contact.scss';
</style>